// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.l-centered-container {
    position: relative;
}
.l-centered {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.l-row-view {
    left: -25px;
    height: 3ch;
    width: 3ch;
    border-radius: 50%;
    background:#005ea8;
    color: white;
}
.l-rv-top {
    top: -25px;
}
.l-rv-bottom {
    bottom: -18px;
}
.p-datatable-resizable .p-datatable-tbody tr td.l-grid-col {
    overflow: auto;
}
.l-grid-col-header {
    display: inline;
}

.l-col-header-helptext {
    position: absolute;
    display: none;
    font-weight: lighter;
    background: #3c3c3c;
    color: white;
    padding: 5px;
    border-radius: 3px;
    top: 50px;
    right: 15px;
    width: 240px;
    z-index: 9999999;
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./lino_react/react/components/GridElement.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;AACA;IACI,WAAW;IACX,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,UAAU;AACd;AACA;IACI,aAAa;AACjB;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB","sourcesContent":[".l-centered-container {\n    position: relative;\n}\n.l-centered {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n.l-row-view {\n    left: -25px;\n    height: 3ch;\n    width: 3ch;\n    border-radius: 50%;\n    background:#005ea8;\n    color: white;\n}\n.l-rv-top {\n    top: -25px;\n}\n.l-rv-bottom {\n    bottom: -18px;\n}\n.p-datatable-resizable .p-datatable-tbody tr td.l-grid-col {\n    overflow: auto;\n}\n.l-grid-col-header {\n    display: inline;\n}\n\n.l-col-header-helptext {\n    position: absolute;\n    display: none;\n    font-weight: lighter;\n    background: #3c3c3c;\n    color: white;\n    padding: 5px;\n    border-radius: 3px;\n    top: 50px;\n    right: 15px;\n    width: 240px;\n    z-index: 9999999;\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
